var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2777_3296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6892 49.0058C7.87584 46.683 4.0625 40.4889 4.0625 30.4235C4.0625 20.358 19.3158 -2.86992 33.8065 1.00141C45.2465 4.87273 52.1105 16.4867 50.5852 31.972C49.0599 47.4573 45.2465 50.5543 40.6705 49.7801C36.0945 49.0058 31.5185 48.2315 27.7052 48.2315C23.8918 49.0058 18.5532 53.6514 11.6892 49.0058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7412 48.9204L11.7413 48.9203L11.7452 48.923C15.1491 51.2267 18.1691 51.2261 20.8166 50.5542C22.1433 50.2175 23.3764 49.7121 24.521 49.24L24.5775 49.2167C25.6971 48.7549 26.7365 48.3262 27.6853 48.1335L27.6951 48.1315L27.7052 48.1315C31.5269 48.1315 36.1095 48.9069 40.6808 49.6804L40.6872 49.6815C41.8181 49.8728 42.8945 49.8238 43.8975 49.4094C44.9001 48.9952 45.8389 48.2119 46.6883 46.9185C48.3902 44.3268 49.7233 39.702 50.4857 31.9622C52.0075 16.5129 45.1614 4.95117 33.7775 1.09717C26.5932 -0.820192 19.1957 3.97629 13.5765 10.5511C10.7701 13.8348 8.41545 17.5534 6.76279 21.078C5.10911 24.6047 4.1625 27.9282 4.1625 30.4235C4.1625 40.467 7.96727 46.6216 11.7412 48.9204Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3296",
    x: 0.0625,
    y: 0.570312,
    width: 54.7344,
    height: 58.4727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3296",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth27);
export default __webpack_public_path__ + "static/media/teeth27.59be4e332a77ce6f76af451251b5b2e3.svg";
export { ForwardRef as ReactComponent };